import { Component, OnInit } from '@angular/core';

import { DomSanitizer } from '@angular/platform-browser';

import { ActivatedRoute } from '@angular/router';

import { OtherService } from 'src/app/Service/other.service';

import axios from 'src/app/Service/axios';

@Component({

  selector: 'app-education',

  templateUrl: './education.component.html',

  styleUrls: ['./education.component.css']

})

export class EducationComponent implements OnInit {

  Info: any;

  lst_Educations: any = [];

  lst_Search: any = [];

  bDetail: boolean = false;

  webAppName = (<any>window).webAppName;

  constructor(

    private otherService: OtherService,

    private sanitizer: DomSanitizer,

    private route: ActivatedRoute

  ) { }

  ngOnInit(): void {

    this.route.paramMap.subscribe((params: any) => {

      if (params.get('id')) {

        this.bDetail = true;

        this.otherService.setTitle(`${this.webAppName} | فیلم های آموزشی انواع ردیاب`);

        this.getEducation(params.get('id'));

      }

      else {

        this.otherService.setTitle(`${this.webAppName} | فیلم های آموزشی انواع ردیاب`);

        this.getListEducation()

      }

    })

  }

  getListEducation = async () => {

    this.otherService.Showspinner();

    const resp = await axios.post(`EducationalContent_List`, {});

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data.toString())

    res.forEach((el: any, index: number) => {

      res[index].strContentPath = this.return_SafeUrl(el.strContentPath);

    })

    this.lst_Educations = res;

    this.lst_Search = res;

  }

  getEducation = async (id) => {

    this.otherService.Showspinner();

    const resp = await axios.post(`EducationalContent_Info?iEducationalContent=${id}`, {});

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data.toString())

    res.forEach((el: any, index: number) => {

      res[index].strContentPath = this.return_SafeUrl(el.strContentPath);

    })

    this.lst_Educations.push(res[0])

  }

  return_SafeUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  subString_Title(text: string, limit?: number) {

    if (limit && text?.length > limit) text = text.slice(0, limit) + '...';

    if (!limit && text?.length > 55) text = text.slice(0, 55) + '...';


    return text;
  }

  openEducation(item) {

    window.open(`/education/${item.iEducationalContent}`, '_blank')

  }

  search_Educations(strValue) {

    if (strValue.length > 1) {

      this.lst_Educations = this.lst_Search.filter((el: any) => {

        return el.strTitle.includes(strValue)

      })

    }

    else if (strValue == '') this.lst_Educations = this.lst_Search;

  }

}
